"use es6";

import { memo } from "../../../utils/memo";
const supportsScrollTimeline = memo(() => window.ScrollTimeline !== undefined);
export { supportsScrollTimeline };